<script>
  import { environment } from '../../environment/environment.js';
  import { productDataStore } from '../../stores/ProductData.js';
  import determineProductColourImageUrl from '../../utils/determineProductColourImageUrl.js';

  export let selectedType;
  export let clickFn;

  const productTypes = environment.PRODUCT_TYPES.map((type) => {
    return {
      key: type,
      availableKey: type + 'sAvailable',
      fallback: `img/design/${type}-not-selected.jpg`,
    };
  });

  // We'll store fetched images here
  let images = {};

  async function fetchProductImage(typeKey) {
    const pd = $productDataStore[typeKey];
    if (!pd) return ''; // or return null if you prefer

    return determineProductColourImageUrl({
      productSlug: pd.rootSlug,
      colourPathName: pd.selectedColour.pathName,
      colourObject: pd.selectedColour,
      imageSize: 128,
      imageType: 'jpg',
      gender: pd.gender,
      availableGenders: [
        pd.selectedColour.mens ? 'mens' : '',
        pd.selectedColour.womens ? 'womens' : '',
        pd.selectedColour.youth ? 'youth' : '',
      ],
      side: 'front',
      showModel: true,
      isModelBasedImages: pd.isModelBasedImages,
      sublimationTemplateId: pd.selectedSublimationTemplate?.SublimationTemplate?.id,
    });
  }

  // Single reactive statement: if a product type is “available” and selected,
  // fetch its image; otherwise, use the fallback image.
  $: {
    productTypes.forEach(async ({ key, availableKey, fallback }) => {
      if ($productDataStore[availableKey] && $productDataStore[key]) {
        images[key] = await fetchProductImage(key);
      } else {
        images[key] = fallback;
      }
    });
  }
</script>

<div class="type">
  {#each productTypes as { key, availableKey, fallback }}
    {#if $productDataStore[availableKey]}
      <div class="card-container">
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <div class="card" on:click={() => clickFn(key)} class:border={selectedType === key}>
          <!-- If the user has actually selected this product type -->
          {#if $productDataStore[key]}
            <img src={images[key]} alt={`preview of selected ${$productDataStore.collection} ${key}`} />
          {:else}
            <!-- Otherwise, show a fallback image -->
            <div class="add">+</div>
            <img src={fallback} alt={`click to select ${key}`} />
          {/if}
        </div>
        <div class="label">{key}</div>
      </div>
    {/if}
  {/each}
</div>

<style>
  .type {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 2rem;
    align-self: baseline;
    grid-auto-rows: 1fr;
  }
  .card-container {
    display: flex;
    flex-direction: column;
    position: relative;
  }

  .label {
    margin-top: 0.5rem;
    display: flex;
    text-align: center;
    font-size: 1.1rem;
    font-weight: 600;
    color: black;
    text-transform: uppercase;
    width: 100%;
    align-items: center;
    justify-content: center;
  }

  .card {
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    border-radius: 1rem;
    flex-direction: column;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.15);
    overflow: hidden;
    padding: 0.5rem;
  }

  .card:not(.border):hover {
    border: 1px solid rgba(0, 0, 0, 0.15);
  }

  .card img {
    width: 100%;
  }

  .border {
    border: 1px solid #fe5900;
  }

  .add {
    position: absolute;
    top: 0;
    right: 0;
    padding-right: 0.5rem;
    color: #fe5900;
    z-index: 10;
  }

  @media screen and (min-width: 600px) {
    .type {
      padding-top: 0;
      margin-top: 0;
      grid-template-columns: 1fr;
    }
  }
</style>
